<div class="card__content">
  <app-row>
    <app-col cols="12" sm="6">
      <div class="card__content-title">
        <app-avatar [round]="true" bgColor="var(--color-lightest)" size="24" iconType="svg" icon="from"></app-avatar>
        <span class="card__content-title-txt">{{ "Shipments.ShipFrom" | translate }}</span>
      </div>

      <p class="card__content-main-txt">{{ shipment.pickUpLocation?.city.name }}</p>
      <app-icon name="edit" (click)="openEditLocationModal(LocationType.Customer)" class="card__content"></app-icon>

      <p class="card__content-subtxt">{{ shipment.customer.title  |mask:isMaskData }}</p>

      <div class="card__content-desc">
        <div class="flex align-center">
          <app-avatar [round]="true" bgColor="var(--color-lightest)" size="24" iconType="svg" icon="contact"></app-avatar>

          <span class="card__content-small-txt" *ngIf="pickUpContact">
            {{pickUpContact.firstName}} {{ pickUpContact.lastName}}: {{pickUpContact.mobileNumber}}
          </span>
          <span class="card__content-small-txt" *ngIf="!pickUpContact">ــــ</span>
        </div>
      </div>
    </app-col>
    <mat-divider class="d-block d-none-sm my-3"></mat-divider>
    <app-col cols="12" sm="6">
      <div class="card__content-title">
        <app-avatar bgColor="var(--color-lightest)" size="24" iconType="svg" icon="to"></app-avatar>
        <span class="card__content-title-txt">{{ "Shipments.ShipTo" | translate }}</span>
      </div>

      <p class="card__content-main-txt">{{ shipment.dropOffLocation?.city.name }}</p>
      <app-icon name="edit" (click)="openEditLocationModal(LocationType.Receiver)" class="card__content"></app-icon>

      <p class="card__content-subtxt">
        <span *ngIf="shipment.receiver?.id">
          <ng-container *ngIf="shipment.noOfCustomers > 1; else elseBlock">
            {{ shipment.noOfCustomers + ' ' + ('sharedFeatures.ShippingCard.Clients' | translate)  |mask:isMaskData }}
          </ng-container>
          <ng-template #elseBlock>{{shipment.receiver?.name  |mask:isMaskData}}</ng-template>
        </span>
        <span *ngIf="shipment.dropOffCustomer">
          <ng-container *ngIf="shipment.noOfCustomers > 1; else elseBlock">
            {{ shipment.noOfCustomers + ' ' + ('sharedFeatures.ShippingCard.Clients' | translate) }}
          </ng-container>
          <ng-template #elseBlock>{{shipment.dropOffCustomer.title  |mask:isMaskData}}</ng-template>
        </span>
      </p>

      <div *ngIf="shipment.noOfOrders > 0">
        <span class="text-400">
          <app-icon class="align-middle" name="bold-location" size="xs"></app-icon>
        </span>
        <span class="small text-400">{{shipment.noOfOrders}} {{'sharedFeatures.ShippingCard.Orders' | translate}}</span>
      </div>

      <div class="card__content-desc">
        <div class="flex align-center">
          <app-avatar [round]="true" bgColor="var(--color-lightest)" size="24" iconType="svg" icon="contact"></app-avatar>

          <span class="card__content-small-txt" *ngIf="dropOffContact">
            {{dropOffContact.firstName}} {{ dropOffContact.lastName}}: {{dropOffContact.mobileNumber}}
          </span>
          <span class="card__content-small-txt" *ngIf="!dropOffContact">ــــ</span>
        </div>

        <div *ngIf="shipment?.shipmentCreationTemplate !== ShipmentCreationTemplateTypes.Cement">
          <app-state-section *ngIf="shipment.status !== ShipmentStatus.New && shipment.status !== ShipmentStatus.Accepted" [state]="sectionState">
            <button
              class="btn--link text-primary"
              [matTooltip]="shipment?.otp ? ('Shipments.OTP' | translate) + ': ' + shipment.otp : null"
              matTooltipPosition="above"
              mat-button
              color="primary"
              (click)="resendDriverOtp()"
            >
              {{"Buttons.ResendOTP" | translate}}
            </button>
          </app-state-section>
        </div>
      </div>
    </app-col>
  </app-row>
</div>
